<template>
	<div class="body">
		<Head type='playback' @tapStatus="changeTap($event)" @out='headOut($event)'></Head>
		<div class="main">
			<div class="left">
				<div class="robot-info">
					<div class="title">
						<div class="icon"><img src="../../../static/imgV2/detail-title.png" /> </div>
						<div class="text">{{ languageJson.robot }}</div>
						<div class="select">
							<el-select :value="robotId" :placeholder="languageJson.SelectRobotPlease" @change="handleRobot">
								<el-option v-for="(item, index) in robotList" :key="index" :value="item.robotId"
									:label="rname(item)" />
							</el-select>
						</div>
						<div class="clear"></div>
					</div>
					<div class="content">
						<div class="item">
							<div class="item-1">{{ languageJson.RecentlyMap }}</div>
							<div class="item-2" v-if="robotId">{{mapName}}-{{lineName}}</div>
						</div>
						<div class="item">
							<div class="item-1">{{ languageJson.RecentlyInspection }}</div>
							<div class="item-2">{{travelDate}}</div>
						</div>
					</div>
				</div>
				<div class="video-list">
					<div class="title">
						<div class="icon"><img src="../../../static/imgV2/detail-title.png" /> </div>
						<div class="text">{{ languageJson.VideoList }}</div>
						<div class="select">
							<el-date-picker @change="changeDate" v-model="date" type="date" format="yyyy-MM-dd"
								:placeholder="languageJson.SelectDate">
							</el-date-picker>
						</div>
						<div class="clear"></div>
					</div>
					<div v-if="videoList.length == 0" class="no-data-1">
						<img src="../../../static/imgV2/none.png" style="width: 30%;" alt="">
						<div style="margin-top: 10px;">{{ languageJson.currentlyAvailable }}</div>
					</div>
					<div class="list">
						<div class="item" v-for="(item,index) in videoList" :key="index" @click="setPath(item)">
							<div class="img">
								<div class="mask" v-if="item.url != videoPath">
									<img class="playStopImgs" :src="playStopImg" v-if="isPrivate"/>
								</div>
								<img :src="item.snap"  v-if="!isPrivate"/>
							</div>
							<div class="content"> 
								<div class="date" v-if="isPrivate">{{item.videoFileName}}</div>
								<div class="date" v-else="!isPrivate">{{formatDate(new Date(item.startDate), "hh:mm:ss")}} -
									{{formatDate(new Date(item.endDate), "hh:mm:ss")}}</div>
								<div class="length" v-show="!isPrivate">{{ languageJson.VideoDuration }}：<span>{{item.duration}}{{ languageJson.divide }}</span></div>
							</div>
							<div class="clear"></div>
						</div>
					</div>
				</div>
			</div>
			<div class="video">
				<div class="title">
					<div class="name">{{ languageJson.PanTiltMainCamera }}</div>
				</div>
				<img class="background" src="../../../static/imgV2/playback-max.png" />
				<div class="no-data" v-if="!videoPath">
					<img src="../../../static/imgV2/no-data.png" />
					<div class="data-text-1">{{ languageJson.Thereiscurrentlynocontentavailable }}</div>
					<div class="data-text-2">{{ languageJson.PleaseClickPlayback }}</div>
				</div>
				<div id="video" class="play"></div>
			</div>
		</div>

		<el-dialog :visible.sync="dialogVisible" width="20%" center>
			<div style="width: 100%;height: 100%;position: relative;">
				<img style="width: 100%;height: 100%;" src="../../../static/imgV2/robotImg.png" alt="">
				<div
					style="position: absolute;width: 100%;top: 30%;font-size: 1.2vw;color: white;font-weight: 600;text-align: center;">
					{{ languageJson.ExitText }}</div>
				<div
					style="position: absolute;left:10%;width: 80%;bottom: 10%;display: flex;justify-content: space-between;">
					<el-button type="primary" style="width: 40%;font-size: 1vw;padding: 0.5vw 0;"
						@click="dialogVisible = false">{{ languageJson.Cancel }}</el-button>
					<el-button type="danger" style="width: 40%;font-size: 1vw;padding: 0.5vw 0;" @click="getOut()">{{ languageJson.Exit }}
					</el-button>
				</div>
			</div>
		</el-dialog>
	</div>
</template>
<script>
	import Head from '@/components/Head.vue';
	import {
		getVideoList,
		queryRobotReplayVideoList,
		robotDetail,
		getVideoRobotList
	} from '@/api/indexV2';
	import {
		getItem,
		setToken,
		setItem,
		removeItem,
		removeToken
	} from '@/utils/auth';
	import Player from 'xgplayer';
	import HlsPlayer from "xgplayer-hls";
  import {PRIVATE} from '../../router/index'
	export default {
		name: '',
		components: {
			Head
		},
		data() {
			return {
				isPrivate:__APP_INFO__.private,
				playStopImg: require('../../../static/imgV2/videoplay.png'),
				languageJson: languageJson,
				tapType: false,
				dialogVisible: false,
				robotList: [],
				robotId: '',
				date: '',
				videoList: [],
				videoPath: '',
				mapName: '',
				lineName: '',
				travelDate: '',
				isDownload: '',
				robotType: {
					"01": "CONCO-X1",
					"02": "CONCO-X3",
					"03": "CONCO-G1",
					"04": "CONCO-S1-02",
					"05": "CONCO-S1-01",
          "06": "CONCO-P1",
          "07": "CONCO-S1-jy",
          "08": "CONCO-X3-01",
          "09": "CONCO-X3-02"
				}
			}
		},
		mounted() {
			this.getRobotInfo();
			this.date = this.formatDate(new Date(), "yyyy-MM-dd")
		},
		methods: {
			rname(item) {
				return item.NAME + "-" + this.robotType[item.robotType];
			},
			changeTap(data) {
				this.tapType = data
			},
			headOut(data) {
				this.dialogVisible = true
			},
			getOut() {
				removeToken()
				removeItem('differtime')
				removeItem('loginSuccess')
				this.dialogVisible = false
				this.$router.push({
					name: 'login'
				})
			},
			getRobotInfo() {
				getVideoRobotList(getItem('tenantInfoId')).then(res => {
					this.robotList = res.data;
				})
			},
			handleRobot(id) {
				this.robotId = id;
				let item = this.robotList.find(item => item.robotId == id);
				this.mapName = item.mapName;
				this.travelDate = item.travelDate;
				this.lineName = item.lineName;
				this.isDownload = item.isDownLoad;
				this.list();
			},
			list() {
				if (!this.robotId) {
					return
				}
				let now = this.date ? this.date : this.formatDate(new Date(), "yyyy-MM-dd");
				let param = {
					robotId: this.robotId,
					startDate: now + ' 00:00:00',
					endDate: now + ' 23:59:59',
					line: '99',
                    isPrivate: PRIVATE,
				}
				if(this.isPrivate){
					delete param.isPrivate;
					delete param.line;
				   	queryRobotReplayVideoList(param).then(res => {
						this.videoList = res.data;
					})
				}else{
					getVideoList(param).then(res => {
						this.videoList = res.data.list;
					})
				}
			},
			changeDate(date) {
				this.date = this.formatDate(date, "yyyy-MM-dd");
				this.list();
			},
			setPath(item) {
				let videoUrl = this.isPrivate ? item.videoUrl : item.url;
					videoUrl = videoUrl.indexOf("https") < 0 ? videoUrl.replaceAll("http", "https") : videoUrl;
				this.videoPath = videoUrl;
				
				const config = {
					"id": "video",
					"url": this.videoPath,
					"playsinline": true,
					"poster": "",
					"plugins": [],
					"width": "99.8%",
					"height": "100%",
					"autoplay": true,
					"volume": false,
					"download": this.checkIsShow(),
				}
				
				if (this.videoPath.indexOf("m3u8") > 1) {
					config.plugins.push(HlsPlayer)
				}
				
				let player = new Player(config);
			},
			formatDate(date, fmt) {
				if (!date) {
					return ""
				}
				if (/(y+)/.test(fmt)) {
					fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
				}
				let o = {
					'M+': date.getMonth() + 1,
					'd+': date.getDate(),
					'h+': date.getHours(),
					'm+': date.getMinutes(),
					's+': date.getSeconds()
				};
				for (let k in o) {
					if (new RegExp(`(${k})`).test(fmt)) {
						fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
					}
				}
				return fmt;
			},
			/**
			 * 判断 是否显示
			 * @returns {boolean}
			 */
			checkIsShow() {
				if (this.videoPath && this.videoPath.indexOf("mp4") > 1 && this.isDownload == '0') {
					return true;
				}
				return false;
			}
		}
	}
</script>
<style scoped lang="less">
	@import "xgplayer.css";
	@import "./index";
	.playStopImgs{width: 50% !important;height: 60% !important;padding-top: 10% !important;padding-left:3% !important;}
</style>



// WEBPACK FOOTER //
// src/page/playback/index.vue